/* istanbul ignore file */
import { FORM_FIELDS } from './form-fields';

export const FORM_PATHS = {
  LANGUAGE: () => FORM_FIELDS.LANGUAGE,
  CONTENT_BODY: () => FORM_FIELDS.CONTENT_BODY,
  BODY: () => FORM_FIELDS.BODY,
  IMGS: () => FORM_FIELDS.IMGS,
  VIDEOS: () => FORM_FIELDS.VIDEOS,
  WEBSITES: () => FORM_FIELDS.WEBSITES,
  INTERNAL_INFORMATION: () => FORM_FIELDS.INTERNAL_INFORMATION,
  LIVE_URLS: () =>
    `${FORM_FIELDS.INTERNAL_INFORMATION}.${FORM_FIELDS.LIVE_URLS}`,
  CONTENT_IDS: () =>
    `${FORM_FIELDS.INTERNAL_INFORMATION}.${FORM_FIELDS.CONTENT_IDS}`,
  ARTICLE_VERSION_LIST: () => FORM_FIELDS.ARTICLE_VERSION_LIST,
  NEXT_STATES: () => FORM_FIELDS.NEXT_STATES,
  SURTITLES: () => FORM_FIELDS.SURTITLES,
  EDITION_LANGUAGE: () => FORM_FIELDS.EDITION_LANGUAGE,
  TYPED_TAGS: () => FORM_FIELDS.TYPED_TAGS,
  TAGS: () => FORM_FIELDS.TAGS,
  TOPICS: () => FORM_FIELDS.TOPICS,
  TOPICS_WITH_TRANSLATIONS: () => FORM_FIELDS.TOPICS_WITH_TRANSLATIONS,
  COMPANIES: () => FORM_FIELDS.COMPANIES,
  PEOPLE: () => FORM_FIELDS.PEOPLE,
  PUBLISH_TIME: () => `${FORM_FIELDS.PUBLISH}.${FORM_FIELDS.DATE}`,
  TIMEZONE: () => `${FORM_FIELDS.PUBLISH}.${FORM_FIELDS.TIMEZONE}`,
  SHOW_PUBLISH_TIME: () =>
    `${FORM_FIELDS.PUBLISH}.${FORM_FIELDS.SHOW_PUBLISH_TIME}`,
  SELECTED_AUTHORS: () => FORM_FIELDS.SELECTED_AUTHORS,
  RESTRICTED_TO_REGISTERED_USERS: () =>
    FORM_FIELDS.RESTRICTED_TO_REGISTERED_USERS,
  NOT_FOR_GOOGLE_NEWS_SITEMAPS: () => FORM_FIELDS.NOT_FOR_GOOGLE_NEWS_SITEMAPS,
  NOT_FOR_NEWS_FEED: () => FORM_FIELDS.NOT_FOR_NEWS_FEED,
  HIDE_THIS_ARTICLE: () => FORM_FIELDS.HIDE_THIS_ARTICLE,
  PAYWALL_PREMIUM_CONTENT: () => FORM_FIELDS.PAYWALL_PREMIUM_CONTENT,
  NOT_FOR_COMPETITORS: () => FORM_FIELDS.NOT_FOR_COMPETITORS,
  CONTENT_SET_HEADLINE: () => FORM_FIELDS.CONTENT_SET_HEADLINE,
  STRAPLINE: () => FORM_FIELDS.STRAPLINE,
  EDITORSNOTE: () => FORM_FIELDS.EDITORSNOTE,
  BANNER_IMAGE: () => FORM_FIELDS.BANNER_IMAGE,
  SPONSOR_LOGOS: () => FORM_FIELDS.SPONSOR_LOGOS,
  PRIMARY_COLOUR_HEX: () => FORM_FIELDS.PRIMARY_COLOUR_HEX,
  SECONDARY_COLOUR_HEX: () => FORM_FIELDS.SECONDARY_COLOUR_HEX,
  HIGHLIGHT_COLOUR_HEX: () => FORM_FIELDS.HIGHLIGHT_COLOUR_HEX,
  CHAPTERS: () => FORM_FIELDS.CHAPTERS,
  LANDING_PAGE_HEADLINE: () => FORM_FIELDS.LANDING_PAGE_HEADLINE,
  HEADLINE: () => FORM_FIELDS.HEADLINE,
  MAIN_IMAGE: () => FORM_FIELDS.MAIN_IMAGE,
  MAIN_VIDEO: () => FORM_FIELDS.MAIN_VIDEO,
  DISPLAY_IMAGE_ON_WEBSITE: () => FORM_FIELDS.DISPLAY_IMAGE_ON_WEBSITE,
};
